module.exports = __webpack_public_path__ + "img/r3.490ae5cc.jpg";